import * as types from '../../action-types';
import {getSingleStipulationAttachment as initialState } from "../../initialState";

const getSingleStipulationAttachment = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_STIPULATION_ATTACHMENT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_STIPULATION_ATTACHMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_STIPULATION_ATTACHMENT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_STIPULATION_ATTACHMENT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSingleStipulationAttachment;

